export default __webpack_public_path__ + "b854345ed5061db0d0fe13e663d33758.png";